import { render, staticRenderFns } from "./StickyComment.vue?vue&type=template&id=19671b10&"
import script from "./StickyComment.vue?vue&type=script&lang=js&"
export * from "./StickyComment.vue?vue&type=script&lang=js&"
import style0 from "./StickyComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StickyComment.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/gutters/StickyComment.vue
// module id = 899
// module chunks = 1